export const generateAnonId = ()=>{
   const rand = Date.now() + Math.random().toString(36).substring(2, 6);
   return 'anonymous_'+rand;
}